// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"310":"a9c9703b","711":"37cdd4fa"}[chunkId] + ".chunk.js";
};